import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import { MENU_OPEN } from 'store/actions';
import appLogo from '../../../assets/images/terminus-images/sbl.jpg';

// ==============================|| MAIN LOGO ||============================== //

/**
 * Returns the correct home route for the currently logged-in user role.
 * Mirrors the redirect logic in AuthLogin.js so the logo always lands
 * on a route that actually exists.
 */
const getHomePath = (accountType) => {
    if (!accountType) return '/';
    if (accountType === 'admin') return '/admin';
    if (accountType === 'staff' || accountType === 'manager') return '/vendor';
    if (accountType === 'vendor') return '/vendor';
    return '/';
};

const LogoSection = () => {
    const defaultId = useSelector((state) => state.customization.defaultId);
    const userInfo = useSelector((state) => state.customization.userInfo);
    const dispatch = useDispatch();

    const homePath = getHomePath(userInfo?.accountType);

    return (
        <ButtonBase disableRipple onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })} component={Link} to={homePath}>
            <img src={appLogo} alt="Terminus Logo" style={{ height: '50px' }} />
        </ButtonBase>
    );
};

export default LogoSection;
